import React from 'react';
import {
  IconButton,
  IconButtonProps,
  makeStyles,
  Theme,
} from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme: Theme) => {
  function generateColorStyles(colorName: 'grid_green' | 'grid_red') {
    const baseColor = theme.palette[colorName];
    return {
      '& > span:first-child': {
        color: theme.palette.getContrastText(baseColor.main),
        backgroundColor: baseColor.main,
      },
      '&:hover > span:first-child, &:focus-visible > span:first-child': {
        color: theme.palette.getContrastText(baseColor.dark),
        backgroundColor: baseColor.dark,
      },
      '&:active > span:first-child': {
        color: theme.palette.getContrastText(baseColor.light),
        backgroundColor: baseColor.light,
      },
      '&:disabled > span:first-child': {
        color: theme.palette.action.disabled,
        backgroundColor: theme.palette.action.disabledBackground,
      },
    };
  }
  return {
    iconButton: {
      borderRadius: 0,
      padding: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'transparent',
      display: 'flex',
      alignItems: 'start',
      outline: 'none !important',

      '& > span:first-child': {
        fontSize: '22px',
        borderRadius: theme.shape.borderRadius,
        width: '30px',
        height: '30px',
        marginTop: '7px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    iconButtonRed: generateColorStyles('grid_red'),
    iconButtonGreen: generateColorStyles('grid_green'),
  };
});

function RowIconButton({
  children,
  color,
  ...rest
}: Omit<IconButtonProps, 'color'> & {
  color: 'grid_green' | 'grid_red' | IconButtonProps['color'];
}) {
  const styles = useStyles();
  return (
    <IconButton
      {...rest}
      disableRipple
      className={classNames(rest.className, styles.iconButton, {
        [styles.iconButtonRed]: color === 'grid_red',
        [styles.iconButtonGreen]: color === 'grid_green',
      })}
    >
      {children}
    </IconButton>
  );
}

export default RowIconButton;
